import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'

const store = CreateGenericSlice<
  CenterViewModel,
  SliceCaseReducers<CenterViewModel>
>({
  name: 'Center',
  initialState: {},
  reducers: {
    setCenter: (state, { payload }: { payload: CenterViewModel }) => {
      state.id = payload.id
      state.name = payload.name
      state.subdomain = payload.subdomain
      state.hasRecord = payload.hasRecord
      state.hasPrescription = payload.hasPrescription
    },
    setCenterConfig: (
      state,
      { payload }: { payload: Array<CenterConfigType> }
    ) => {
      state.centerConfigs = payload
    },
    clearCenter: (state, payload) => {
      state.id = undefined
      state.name = undefined
      state.subdomain = undefined
      state.centerConfigs = undefined
    },
  },
})

export const { setCenter, setCenterConfig, clearCenter } = store.actions

export default store.reducer
